import { css } from "@emotion/react";

import { colors } from "@styles";

export const form = css`
  width: 100%;
  text-align: left;
`;

export const alignCenter = css`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const marginTop = css`
  margin-top: 1.5rem;
`;

export const icon = css`
  margin-right: 0.5rem;
  color: ${colors.primary};
`;
